// @ts-check
import NoSlotsAvailablePicker from './NoSlotsAvailablePicker';

export default NoSlotsAvailablePicker;
